import avalon from "avalon";
import slider from "slider";
import pagination from "pagination";
import ajax from "ajax";
import tool from "toolLoaderPC";
import $ from "jquery";
import { webp } from "aiyuke-front-lib";

var vmodel = avalon.define({
    $id: "indexController",
    menu: "lastReply",
    type: "",
    recommendTop: 575,
    // 切换菜单
    toggleMenu: function(type) {
        vmodel.menu = type.toString();
        switch (type) {
            case "lastReply":
                ajax.pjax(window.server.loadNewReplyUrl + "&page=1");
                break;
            case "new":
                ajax.pjax(window.server.loadNewUrl + "&page=1");
                break;
            case "hot":
                ajax.pjax(window.server.loadHotUrl + "&page=1");
                break;
            case "used":
                ajax.pjax(window.server.loadErUrl + "&page=1");
                break;
        }
        tool.scrollTo(1);
        tool.scrollTo(0);
        // $(window).scroll();
        // $('.lazy-background').lazyload({
        //     appear: true
        // });
    },
    jump: function(url) {
        ajax.pjax(url);
    },
    newReplyPage: {},
    newReplyPagination: [],
    newReplyGoPage: function(page) {
        if (page.disable) {
            return;
        }
        ajax.pjax(window.server.loadNewReplyUrl + "&page=" + page.target);
    },
    newPage: {},
    newPagination: [],
    newGoPage: function(page) {
        if (page.disable) {
            return;
        }
        ajax.pjax(window.server.loadNewUrl + "&page=" + page.target);
    },
    hotPage: {},
    hotPagination: [],
    hotGoPage: function(page) {
        if (page.disable) {
            return;
        }
        ajax.pjax(window.server.loadHotUrl + "&page=" + page.target);
    },
    erPage: {},
    erPagination: [],
    erGoPage: function(page) {
        if (page.disable) {
            return;
        }
        ajax.pjax(window.server.loadErUrl + "&page=" + page.target);
    }
});

export default {
    init: function() {
        vmodel.newReplyPage = window.server.NewReplyPage;
        vmodel.newPage = window.server.NewPage;
        vmodel.hotPage = window.server.HotPage;
        vmodel.erPage = window.server.ErPage;
        vmodel.type = window.server.type || 2;
        if (vmodel.type == 1) {
            vmodel.menu = "new";
        } else if (vmodel.type == 2) {
            vmodel.menu = "hot";
        } else if (vmodel.type == 3) {
            vmodel.menu = "lastReply";
        } else if (vmodel.type == 4) {
            vmodel.menu = "used";
        }
        // switch(vmodel.type){
        //         case 1 : vmodel.menu = 'new' ; break;
        //         case 2 : vmodel.menu = 'hot' ; break;
        //         case 3 : vmodel.menu = 'lastReply' ; break;
        //         case 4 : vmodel.menu = 'used' ;  break;
        //     }
        // 轮播图
        var imgs = [];
        $.each(window.server.banner, function(i, img) {
            imgs.push(webp.replaceSrcH5(img.image));
        });
        var sliderInstance = slider.init({
            selector: "#js-slider",
            height: 338,
            width: 600,
            auto: true,
            forBg: true,
            imgs: imgs,
            onClick: function(index) {
                ajax.newPage(window.server.banner[parseInt(index) - 1].url);
            },
            pagination: {
                selector: "#js-slider-pagination",
                width: "100%",
                height: 10,
                itemWidth: 10,
                maxItemLength: 100,
                render: function(item) {
                    return item.html();
                }
            }
        });

        // 懒加载
        $(".lazy-background").lazyload({
            effect: "fadeIn",
            placeholder: webp.replaceSrcH5(
                window.server.cdnHost + "/dest/quanzi/images/default200.jpg"
            ),
            threshold: 300
        });
        vmodel.newReplyPagination = pagination.init(
            vmodel.newReplyPage.total_count,
            vmodel.newReplyPage.page,
            vmodel.newReplyPage.page_size
        );
        vmodel.newPagination = pagination.init(
            vmodel.newPage.total_count,
            vmodel.newPage.page,
            vmodel.newPage.page_size
        );
        vmodel.hotPagination = pagination.init(
            vmodel.hotPage.total_count,
            vmodel.hotPage.page,
            vmodel.hotPage.page_size
        );
        vmodel.erPagination = pagination.init(
            vmodel.erPage.total_count,
            vmodel.erPage.page,
            vmodel.erPage.page_size
        );
        // 实例化编辑器
        // 建议使用工厂方法getEditor创建和引用编辑器实例，如果在某个闭包下引用该编辑器，直接调用UE.getEditor('editor')就能拿到相关的实例
        // var ue = UE.getEditor('editor', {
        //    toolbars: [
        //        ['hello','fontsize', 'bold', 'italic', 'forecolor', 'insertorderedlist', 'insertunorderedlist', 'blockquote', 'simpleupload', 'insertimage', 'insertvideo', 'link', 'justifyleft', 'justifycenter', 'justifyright', 'preview', 'fullscreen']
        //    ],
        //    autoHeightEnabled: false
        // });

        //
        // setTimeout(function(){
        //    alert(123);
        //    ajax.pjax('http://quanzi.devtiyushe.com/group/index.html');
        // }, 500)
        tool.onWindowScroll.on(function(e, top) {
            let height = document.documentElement.clientHeight;
            let scrollHeight = document.documentElement.scrollHeight;
            if (height > 680) {
                if (top < 555) {
                    vmodel.recommendTop = 575 - top;
                } else {
                    vmodel.recommendTop = 20;
                }
            } else {
                if (top < 555) {
                    vmodel.recommendTop = 575 - top;
                } else if (top > scrollHeight - 680) {
                    vmodel.recommendTop = scrollHeight - 680 - top + 20;
                } else {
                    vmodel.recommendTop = 20;
                }
            }
        });
    },
    clear: function() {}
};
